<template>
  <div class="main">
    <homePage></homePage>
    <img class='topBtn' :src='topBtn'  @click='intoView("main")'>
  </div>
</template>

<script>
import homePage from './components/homePage'

export default {
  name: 'App',
  data () {
    return {
      topBtn: require('./assets/img/backtotop_btn.png')
    }
  },
  components: {
    homePage
  },
  methods: {
    intoView (data) {
      document.getElementsByClassName(data)[0].scrollIntoView()
    }
  }
}
</script>

<style>
html, body {
  width: 100%;
  height: 100%;
  margin: 0px;
  padding: 0px;
  min-width: 1263px;
}
.main {
  height: 100%;
  width: 100%;
  margin: 0px;
  padding: 0px;
}
.topBtn {
  width:50px;
  height:50px;
  position:fixed;
  bottom:50px;
  right:30px;
  opacity:0.7;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/App.vue